
<template>
  <div class="loginPage">
    <div class="loginbg">
      <div class="login">
        <iframe v-if="true" style="border:0px" :src="QrCodeUri" width="400px" height="400px"></iframe>
        <div>
          <el-select
            style="width:160px"
            v-if="roleDialogVisible"
            v-model="roleValue"
            placeholder="请选择登录角色"
            @change="selectRole"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="
        item.roleId==='dtsc'?'大唐思拓管理员':
        item.roleId==='admin'?'企业管理员':
        item.roleId==='guard'?'企业门卫':
        item.roleId==='employee'?'企业内部员工':'访客'
        "
              :value="item.roleId"
            ></el-option>
          </el-select>
          <el-select style="width:160px" v-if="dialogVisible" v-model="value" placeholder="请选择值班岗亭">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-button
            v-if="roleDialogVisible||dialogVisible"
            type="success"
            @click="selectPost()"
          >进入系统</el-button>
           <div style="display:none;">
            <br />
            <br />
            <br />
            <span style="margin-right:10px;">测试账号:</span>
            <el-input v-model="LoginUnionid" size="mini" placeholder="请输入用户Unionid" style="width:300px"></el-input>
             <el-button slot="append" size="mini"  @click="loginByUid(LoginUnionid)">测试账号登陆</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import {
  getQrCodeUri,
  getWxToken,
  getWxUserInfo,
  getUserInfoByUnionId,
  getUserRoleList,
  getUserInfoById,
  getToken,
  getDoorList,
  loginError,
  getNavigationBars
} from "@/api/api";
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";

export default {
  name: "qrCode",
  data() {
    return {
      QrCodeUri: "",
      dialogVisible: false, //显示值班岗亭
      roleDialogVisible: false,
      roleOptions: [],
      roleValue: null,
      options: [],
      value: null,
      timer: "",
      LoginUnionid:'obNLAvwbXHvcNvcIQ2sXHp_pJJ8c'
    };
  },
  mounted() {
    //1.初始化二维码
    getQrCodeUri().then(res => {
      this.QrCodeUri = res.data;
    });
    //2.监听url中是否带有code
    var code = this.GetUrlParame("code");
    if (code != undefined) {
      var data = { params: { code: code } };
      var _this = this;
      getWxToken(data).then(wxToken_res => {
        if (wxToken_res.data.access_token === undefined) {
          _this.errorMessage("获取WxToken失败，请联系管理人员！");
          return;
        }
        data = {
          params: {
            accessToken: wxToken_res.data.access_token,
            openId: wxToken_res.data.openid
          }
        };
        getWxUserInfo(data).then(wxUser_res => {
          if (wxUser_res.data.unionid === undefined) {
            _this.errorMessage("获取WxUser失败，请联系管理人员！");
            loginError();
            return;
          }
          window.localStorage.wxUser = JSON.stringify(wxUser_res.data);
          this.loginByUid(wxUser_res.data.unionid);
        });
      });
    }
  },
  methods: {
    errorMessage(error) {
      this.$alert(error, "提示", {
        confirmButtonText: "确定",
        callback: action => {
          this.$router.push("/login");
          this.$router.go(0);
        }
      });
    },
    // 截取code值
    GetUrlParame(parameName) {
      /// 获取地址栏指定参数的值
      /// <param name="parameName">参数名</param>
      // 获取url中跟在问号后面的部分
      var parames = decodeURIComponent(window.location.href);
      //alert(parames);
      // 检测参数是否存在
      if (parames.indexOf(parameName) > -1) {
        var parameValue = "";
        parameValue = parames.substring(
          parames.indexOf(parameName),
          parames.length
        );

        // 检测后面是否还有参数
        if (parameValue.indexOf("&") > -1) {
          // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
          parameValue = parameValue.substring(0, parameValue.indexOf("&"));
          // 去掉参数名, 得到最终纯值字符串
          parameValue = parameValue.replace(parameName + "=", "");
          return parameValue;
        }
        return "";
      }
    },
    loginByUid(unionId) {
      var _this = this;
      var data = { params: { unionId: unionId } };
      getUserInfoByUnionId(data).then(userInfo_res => {
        if (userInfo_res.data.data === undefined) {
          _this.errorMessage("当前用户未注册，请用移动端注册后再扫描登陆！");
          loginError();
          return;
        }
        var userJson = userInfo_res.data.data;
        if (userJson.companyId === undefined) {
          _this.errorMessage("当前用户未注册公司！");
          loginError();
          return;
        }
        window.localStorage.user = JSON.stringify(userJson);
        data = { params: { userId: userJson.id } };
        getToken(data).then(data => {
          var token = data.data.access_token;
          if (token.length > 0) {
            _this.$store.commit("saveToken", token);
            _this.$store.commit(
              "saveTokenExpire",
              new Date(data.data.expires_at)
            );
            data = { params: { userId: userInfo_res.data.data.id } };
            getUserRoleList(data).then(userRole_res => {
              userRole_res.data.data.forEach(element => {
                if (
                  element.roleId === "dtsc" ||
                  element.roleId === "admin" ||
                  element.roleId === "guard"
                ) {
                  _this.roleOptions.push(element);
                  var selRole = window.localStorage.selRole;
                  if (selRole != undefined && selRole === element.roleId) {
                    _this.roleValue = selRole;
                  }
                }
              });
              if (_this.roleOptions.length === 0) {
                _this.$message({
                  message: "该系统只能门卫和企业管理员才能进入！",
                  type: "error"
                });
                loginError();
                return;
              } else {
                _this.roleDialogVisible = true;
                if (
                  _this.roleOptions.length === 1 &&
                  _this.roleOptions[0].roleId != "guard"
                ) {
                  _this.roleValue = _this.roleOptions[0].roleId;
                  _this.inputWin();
                } else {
                  getDoorList({
                    params: { companyId: userJson.companyId }
                  }).then(door_res => {
                    if (door_res.data.data[0] === undefined) {
                      _this.errorMessage("请在移动端注册公司添加岗亭！");
                      loginError();
                      return;
                    }
                    if (_this.roleOptions.length === 1) {
                      _this.roleValue = _this.roleOptions[0].roleId;
                    }
                    if (
                      _this.roleOptions.length === 1 &&
                      door_res.data.data.length === 1
                    ) {
                      _this.value = door_res.data.data[0].id;
                      _this.inputWin();
                    } else {
                      door_res.data.data.forEach(element => {
                        var selDoor = window.localStorage.selDoor;
                        if (selDoor != undefined && selDoor === element.id) {
                          _this.value = selDoor;
                        }
                      });
                      _this.options = door_res.data.data;
                      this.selectRole();
                    }
                  });
                }
              }
            });
          } else {
            _this.errorMessage("获取用户Token失败，请联系管理员！");
            loginError();
            return;
          }
        });
      });
    },
    //选择角色
    selectRole() {
      if (this.roleValue != "guard") {
        this.dialogVisible = false;
      } else {
        this.dialogVisible = true;
      }
    },
    //选择角色或者岗位后提交
    selectPost() {
      if (this.roleDialogVisible) {
        if (this.roleValue === null || this.roleValue === "") {
          this.errorMessage("请选择角色");
          return;
        }
      }
      if (this.dialogVisible) {
        if (this.value === null || this.value === "") {
          this.errorMessage("请选择岗亭");
          return;
        }
      }
      this.inputWin();
    },
    //进入系统
    inputWin() {
      window.localStorage.selRole = this.roleValue;
      window.localStorage.selDoor = this.value;
      var userModel = JSON.parse(window.localStorage.user);
      if (this.options.length > 0) {
        userModel.door = this.options.find(a => a.id === this.value);
        if (userModel.door != undefined) {
          var door = userModel.door;
          door.userId = userModel.id;
        }
      }
      window.localStorage.user = JSON.stringify(userModel);
      if (userModel.id != undefined) {
        let bar = getNavigationBars(this.roleValue);
        window.localStorage.router = JSON.stringify(bar.response.children);
        let getRouter = bar.response.children; //后台拿到路由
        getRouter = filterAsyncRouter(getRouter); //过滤路由
        router.$addRoutes(getRouter); //动态添加路由
        if (this.roleValue === "dtsc") {
          this.$router.replace({
            path: "/fksys/checkCompany"
          });
        } else if (this.roleValue === "admin") {
          this.$router.replace({
            path: "/fksys/otherMgr"
          });
        } else if (this.roleValue === "guard") {
          this.$router.replace({
            path: "/fksys/index"
          });
        } else {
          this.$message({
            message: "该系统只能门卫和企业管理员才能进入！",
            type: "error"
          });
          loginError();
          return;
        }
        //window.location.reload(); //开发时需要隐藏
        this.timer = setInterval(this.ShuaXin, 1000);
        //window.location.reload();
        // this.$router.replace(
        //   this.$route.query.redirect ? this.$route.query.redirect : "/"
        // );
      }
    },
    ShuaXin() {
      this.$router.go();
      clearInterval(this.timer);
    }
  }
};
</script>
 
<style>
* {
  margin: 0;
  font-family: 微软雅黑;
  padding: 0;
}
.loginPage {
  height: 100%;
  background-color: #16a0f8;
  color: #fff;
  overflow: hidden;
  text-align: center;
}
body {
  background-image: url("../assets/ai1.png"), url("../assets/ai2.png");
  background-position: left bottom, right bottom;
  background-repeat: no-repeat, no-repeat, repeat-x;
}
div.loginbg {
  background-image: url("../assets/build.png"), url("../assets/loginbg.png");
  background-position: left bottom, left top;
  background-repeat: repeat-x, repeat-x;
  height: 100%;
  width: 100%;
  position: absolute;
  right: 0px;
  bottom: -10px;
  z-index: 3;
  animation: movebg 80s linear infinite;
}
@keyframes movebg {
  0% {
    background-position: left bottom, left top;
  }

  50% {
    background-position: right bottom, right top;
  }

  100% {
    background-position: left bottom, left top;
  }
}
.login {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 500px;
  width: 500px;
  text-align: center;
  margin-left: -250px;
  margin-top: -250px;
}
.login > strong {
  display: block;
  font-size: 36px;
  height: 60px;
  line-height: 60px;
}
.login > p {
  padding-bottom: 10px;
}
.login > div > img {
  height: 300px;
}
.login > span {
  font-size: 12px;
  display: block;
  padding: 5px;
}
</style>




// WEBPACK FOOTER //
// src/views/Login.vue